import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';
import { ScreenOrientation } from '@/resources/enum/ScreenOrientation';

type State = {
  orientation: ScreenOrientation;
};

function createState(): State {
  const state: State = {} as State;
  clearState(state);
  return state;
}

function clearState(state: State): void {
  state.orientation = ScreenOrientation.None;
}

const getters: GetterTree<State, RootState> = {
  orientation(state: State): ScreenOrientation {
    return state.orientation;
  }
};

const mutations: MutationTree<State> = {
  setOrientation(state: State, payload: ScreenOrientation) {
    state.orientation = payload;
  },

  clearState(state: State) {
    clearState(state);
  }
};

const actions: ActionTree<State, RootState> = {
  clearState(context: ActionContext<State, RootState>): void {
    context.commit('clearState');
  }
};

export const orientation: Module<State, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};
